export const statuses = {
    faulty: {
        label: 'Faulty',
        colour: '#f30'
    },
    warning: {
        label: 'Warning',
        colour: '#f90'
    },
    inactive: {
        label: 'Inactive',
        colour: '#999'
    },
    healthy: {
        label: 'Healthy',
        colour: '#3c0'
    },
    uninstalled: {
        label: 'Uninstalled',
        colour: '#ccc'
    }
}

export const columnOffsets = {
    ID: 0, SERIAL: 1, TYPE: 2, CODE: 3, QR_CODE: 4, NAME: 5,
    CUSTOMER: 7, SITE: 8, LAST_REPORTED: 9, STATUS: 10,
    SW_VERSION: 11, HW_VERSION: 12, ICON: 13, VEHICLE: 14,
    TEST_STATUS: 15, MONITORED: 16, OFFLINE_ALERT: 17
}

export const deviceTypes = [
    {value: "PDU", label: "Personal Detection Unit (PDU)", cred: false, connect: false},
    {value: "GDU", label: "GPS Detection Unit (GDU)", cred: false, connect: false},
    {value: "VDU", label: "Vehicle Detection Unit (VDU)", cred: false, connect: true},
    {value: "APT", label: "Access Point (APT)", cred: true, connect: true},
    {value: "MST", label: "Master (MST)", cred: true, connect: true},
    {value: "SND", label: "Sounder	(SND)", cred: false, connect: false},
    {value: "SNL", label: "Sounder Lite (SNL)", cred: false, connect: false},
    {value: "SAP", label: "Sounder APT (SAP)", cred: false, connect: false},
    {value: "SPK", label: "Loudspeaker Box (SPK)", cred: false, connect: false},
    {value: "MCH", label: "Multi Charger (MCH)", cred: false, connect: true},
    {value: "VEH", label: "SonaSafe Vehicle Number (VEH)", cred: false, connect: false},
    {value: "CAS", label: "Charger Case (CAS)", cred: false, connect: false},
    {value: "CAM", label: "Camera (CAM)", cred: false, connect: false, monitor: false, configuration: false},
    {value: "UTS", label: "Utility Sounder (UTS)", cred: false, connect: false},
    {value: "KSK", label: "Kiosk (KSK)", cred: true, connect: false},
    {value: "LVU", label: "Light Vehicle Unit (LVU)", cred: true, connect: true}
]

export function getDeviceType(type){
    let match = /^([A-Z]{3})/.exec(type)
    if (match){
        type = match[1]
    }
    else{
        let match = /^([A-Z])/.exec(type)
        if (match){
            type = match[1]
            return deviceTypes.find(dt => dt.value.charAt(0) === type)
        }
    }
    return deviceTypes.find(dt => dt.value === type)
}
